import React, { useState } from 'react';

const WorkflowDiagram = ({ currentStep = 0 }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  
  const steps = [
    { id: 1, label: 'Upload Data', icon: 'fas fa-upload', completed: false },
    { id: 2, label: 'Run Regression', icon: 'fas fa-chart-line', completed: false },
    { id: 3, label: 'Diagnostics', icon: 'fas fa-chart-bar', completed: false },
    { id: 4, label: 'Interpretation', icon: 'fas fa-lightbulb', completed: false }
  ];

  // Reverse the steps array to show bottom to top
  const reversedSteps = [...steps].reverse();

  return (
    <div className={`workflow-diagram ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="workflow-header" onClick={() => setIsCollapsed(!isCollapsed)}>
        <h4>Workflow</h4>
        <button className="workflow-toggle-btn">
          <i className={`fas fa-chevron-${isCollapsed ? 'up' : 'down'}`}></i>
        </button>
      </div>
      
      <div className={`workflow-timeline ${isCollapsed ? 'hidden' : ''}`}>
        {reversedSteps.map((step, index) => {
          // Calculate the correct step index for the original order
          const originalIndex = steps.length - 1 - index;
          
          return (
            <div 
              key={step.id} 
              className={`workflow-step ${
                originalIndex < currentStep ? 'completed' : 
                originalIndex === currentStep ? 'current' : 'pending'
              }`}
            >
              <div className="step-content">
                <div className="step-dot">
                  <i className={step.icon}></i>
                </div>
                
                <div className="step-info">
                  <span className="step-label">{step.label}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default WorkflowDiagram;